import configureStore from './configureStore';

// Redux Store
const initialState = window.REDUX_INITIAL_STATE || {};
const store = configureStore(initialState);

export default store;
